import { SubFormProps } from '@forms/Components/types';
import { useFormikValues } from '@hooks/useFormikValues';
import { Field } from 'formik';
import { FormikTimePicker } from '@forms/Components/TimePicker';
import withSubForm from '@forms/Components/withSubForm';
import { operatingHoursFormValidation } from './types';

import styles from './Consignee.module.css';
import { FormikReadonlyInput } from '@forms/Components/ReadonlyInput';

function OperatingHoursForm(props: SubFormProps) {
	useFormikValues(props);

	return (
		<fieldset className={styles['operating-hours-form']}>
			<legend className={styles['legend']}>{props.fieldProps.label}</legend>

			<div className={styles['operating-hours']}>
				<label className={styles['weekday-lbl']}>Weekday</label>
				<label className={styles['saturday-lbl']}>Saturday</label>
				<label className={styles['sunday-lbl']}>Sunday</label>

				{props.fieldProps.readonly ? (
					<OperatingHoursReadonlyForm />
				) : (
					<>
						<Field
							name='weekdayFrom'
							component={FormikTimePicker}
							label='From'
							className={styles['weekday-from']}
						/>

						<Field
							name='weekdayTo'
							component={FormikTimePicker}
							label='To'
							className={styles['weekday-to']}
						/>

						<Field
							name='saturdayFrom'
							component={FormikTimePicker}
							label='From'
							className={styles['saturday-from']}
						/>

						<Field
							name='saturdayTo'
							component={FormikTimePicker}
							label='To'
							className={styles['saturday-to']}
						/>

						<Field
							name='sundayFrom'
							component={FormikTimePicker}
							label='From'
							className={styles['sunday-from']}
						/>

						<Field
							name='sundayTo'
							component={FormikTimePicker}
							label='To'
							className={styles['sunday-to']}
						/>
					</>
				)}
			</div>
		</fieldset>
	);
}

function OperatingHoursReadonlyForm() {
	return (
		<>
			<Field
				name='weekdayFrom'
				component={FormikReadonlyInput}
				label='From'
				className={styles['weekday-from']}
				dayjsFormat='HH:mm'
			/>

			<Field
				name='weekdayTo'
				component={FormikReadonlyInput}
				label='To'
				className={styles['weekday-to']}
				dayjsFormat='HH:mm'
			/>

			<Field
				name='saturdayFrom'
				component={FormikReadonlyInput}
				label='From'
				className={styles['saturday-from']}
				dayjsFormat='HH:mm'
			/>

			<Field
				name='saturdayTo'
				component={FormikReadonlyInput}
				label='To'
				className={styles['saturday-to']}
				dayjsFormat='HH:mm'
			/>

			<Field
				name='sundayFrom'
				component={FormikReadonlyInput}
				label='From'
				className={styles['sunday-from']}
				dayjsFormat='HH:mm'
			/>

			<Field
				name='sundayTo'
				component={FormikReadonlyInput}
				label='To'
				className={styles['sunday-to']}
				dayjsFormat='HH:mm'
			/>
		</>
	);
}

export const OperatingHoursSubform = withSubForm(OperatingHoursForm, operatingHoursFormValidation);
